<template>
  <div class="grid grid-cols-12">
    <div class="col-span-3 p-8 pt-16 lg:p-12 lg:pl-14 bg-transaction-gradient
                space-y-12">
      <ValueInput v-model.trim="$v.form.sum.$model"
                  :label="$t('sum')"
                  :currency_id="!!form.account ? form.account.currency.id : null"
                  :class="{'--error':$v.form.sum.$error}"
                  :disabled="transaction_item.status === 0">
        <template v-slot:errors="">
          <div class="error" v-if="$v.form.sum.$invalid">{{ $t('fieldRequired') }}</div>
        </template>
      </ValueInput>
      <ValueInput v-model="$v.form.fee.$model"
                  v-if="!!form.account && !!form.account.commission && (transaction_item.type === 2)"
                  :label="$t('commission')"
                  :currency_id="!!form.account ? form.account.currency.id : null"
                  :disabled="transaction_item.status === 0">
      </ValueInput>
    </div>
    <div class="col-span-9
                p-8 pt-16 lg:p-12 lg:pr-17
                grid grid-cols-2 col-gap-12 row-gap-12">
      <AccountsSelect v-model="form.account"
                      :label="transaction_item.type === 1 ? $t('accountTo') : $t('accountFrom')"
                      hidden-mode="keep-selected"
                      :accounts="accounts.data"
                      :account_groups="accounts_by_groups"
                      :grouped="accounts_by_groups.length > 1"
                      :disabled="transaction_item.status === 0"
                      @open="open_form = true"/>
      <BaseSelect v-model="form.incomeCategory"
                  v-if="transaction_item.type === 1"
                  :options="incomes"
                  :class="{'--error':$v.form.incomeCategory.$error}"
                  :allow-empty="false"
                  :disabled="transaction_item.status === 0"
                  :selectLabel="$t('categoryIncome')"
                  class="col-span-1"
                  track-by="id"
                  label="title">
        <template v-slot:errors>
          <div class="error" v-if="$v.form.incomeCategory.$invalid">{{ $t('fieldRequired') }}</div>
        </template>
      </BaseSelect>
      <BaseSelect v-model="form.expenseCategory"
                  v-else-if="transaction_item.type === 2"
                  :options="expenses_by_groups"
                  class="col-span-1"
                  :class="{'--error':$v.form.expenseCategory.$error}"
                  :allow-empty="false"
                  :group-select="false"
                  :searchable="true"
                  :show-labels="false"
                  :disabled="transaction_item.status === 0"
                  :select-label="$t('categoryExpense')"
                  track-by="id"
                  label="title"
                  group-label="title"
                  group-values="childs">
        <template v-slot:errors>
          <div class="error" v-if="$v.form.expenseCategory.$invalid">{{ $t('fieldRequired') }}</div>
        </template>
      </BaseSelect>
      <BaseCheckbox v-if="!!transaction_item.import_id" :checked="form.update_categories"
                    size="sm"
                    class="col-start-2 -mt-5"
                    :disabled="transaction_item.status === 0"
                    @change="form.update_categories = !form.update_categories">
        <span class="text-sm">{{ $t('updateCategoriesText') }}</span>
      </BaseCheckbox>

      <BaseSelect v-if="transaction_options['agent'] && $store.getters['space/spaceUseContractors']"
                  class="col-span-1"
                  v-model="form.contractor"
                  :options="computedContractors"
                  :allow-empty="true"
                  :show-labels="false"
                  :disabled="transaction_item.status === 0"
                  :select-label="$t('contractor')"
                  track-by="id"
                  label="title"
                  placeholder="Выберите ...">
        <template v-slot:noOptions="">
          <div class="w-full whitespace-normal">
            {{ $t('noContractors') }}
            <router-link :to="{name:'settings-contractors'}" class="text-red">
              {{ $t('noContractorsHere') }}
            </router-link>
          </div>
        </template>
      </BaseSelect>
      <BaseTextarea v-if="transaction_options['comment']"
                    class="col-span-2"
                    v-model="form.comment"
                    :label="$t('comment')"
                    :readonly="transaction_item.status === 0"/>
      <BaseSelect v-if="transaction_options['tags']"
                  class="col-span-1"
                  v-model="form.tags"
                  :options="tags_list"
                  :close-on-select="false"
                  :multiple="true"
                  :taggable="true"
                  :show-labels="false"
                  :disabled="transaction_item.status === 0"
                  :selectLabel="$t('tags')"
                  :tag-placeholder="$t('tagCreateNew')"
                  track-by="id"
                  label="title"
                  @tag="addTag">
        <template v-slot:noOptions>
          <div class="w-full whitespace-normal">
            {{ $t('noTags') }}
          </div>
        </template>
      </BaseSelect>
      <div class="col-span-2 grid grid-cols-2 col-gap-12">
        <VueCtkDateTimePicker v-model="form.date"
                              id="transaction-date"
                              format="YYYY-MM-DD"
                              formatted="DD.MM.YYYY"
                              :locale="$i18n.locale"
                              :label="$t('dateLabel')"
                              :auto-close="true"
                              :only-date="true"
                              :no-clear-button="true"
                              :no-button="true"
                              :disabled="transaction_item.status === 0"
                              color="#2D4C5E"/>
        <VueCtkDateTimePicker v-if="current_space.data.time_enabled"
                              id="transaction-time"
                              v-model="form.time"
                              format="HH:mm"
                              formatted="HH:mm"
                              :locale="$i18n.locale"
                              :label="$t('timeLabel')"
                              :only-time="true"
                              :no-clear-button="true"
                              :no-button="true"
                              :disabled="transaction_item.status === 0"
                              color="#2D4C5E"/>
      </div>
      <BaseCheckbox :checked="form.off_report"
                    size="sm"
                    class="-mt-5"
                    :disabled="transaction_item.status === 0"
                    @change="form.off_report = !form.off_report">
        <span class="text-sm">{{ $t('isReportText') }}</span>
      </BaseCheckbox>
      <BaseCheckbox :checked="form.off_budget"
                    size="sm"
                    class="-mt-5"
                    :disabled="transaction_item.status === 0"
                    @change="form.off_budget = !form.off_budget">
        <span class="text-sm">{{ $t('isBudgetText') }}</span>
      </BaseCheckbox>
      <PendingStatusInfo v-if="transaction_item.status === 0"/>
      <div class="col-span-2 flex items-center">
        <BaseButton @click="saveChanges" v-if="transaction_item.status !== 0"
                    class="mr-8"
                    style="width: 255px;"
                    :loading="submitted"
                    theme="gray">
          {{ $t('saveChanges') }}
        </BaseButton>
        <BaseButton @click="$emit('cancel')"
                    style="width: 140px;"
                    :loading="submitted"
                    theme="white">
          {{ $t('cancel') }}
        </BaseButton>
        <ArchiveBtn class="ml-auto"
                    @confirm="removeOperation"
                    :submitted="submitted">
          <template v-slot:text>
            {{ $t('remove') }}
          </template>
        </ArchiveBtn>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {decimal, required, requiredIf} from "vuelidate/lib/validators";
import ValueInput from "@/components/UI/BaseInput/ValueInput";
import AccountsSelect from "@/components/UI/BaseSelect/AccountsSelect";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import BaseButton from "@/components/UI/BaseButton";
import BaseTextarea from "@/components/UI/BaseTextarea";
import BaseCheckbox from "@/components/UI/BaseCheckbox";
import IconTrash from "@/components/icons/IconTrash";
import TransactionEditModalFormRemoveButton
  from "@/components/common/Transaction/TransactionEditModal/TransactionEditModalFormRemoveButton";
import ArchiveBtn from "@/components/UI/ArchiveBtn";
import PendingStatusInfo from "@/components/common/Transaction/TransactionEditForm/PendingStatusInfo";

export default {
  name: "TransactionEditFormDefault",
  components: {
    PendingStatusInfo,
    ArchiveBtn,
    TransactionEditModalFormRemoveButton,
    IconTrash, BaseCheckbox, BaseTextarea, BaseButton, BaseSelect, AccountsSelect, ValueInput
  },
  props: {
    transaction_item: {
      required: true
    },
    transaction_options: {
      required: true
    },
    submitted: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      form: {
        sum: null,
        fee: null,
        account: null,
        expenseCategory: null,
        incomeCategory: null,
        contractor: null,
        comment: '',
        tags: [],
        date: null,
        time: null,
        off_report: false,
        off_budget: false,
        update_categories: false
      }
    }
  },
  validations: {
    form: {
      sum: {
        required,
        decimal,
      },
      fee: {
        decimal,
      },
      expenseCategory: {
        required: requiredIf(function () {
          return this.transaction_item.type === 2
        }),
      },
      incomeCategory: {
        required: requiredIf(function () {
          return this.transaction_item.type === 1
        }),
      },
    }
  },
  computed: {
    ...mapState('space', ['current_space']),
    ...mapState('space/expenses', ['expenses']),
    ...mapState('space/incomes', ['incomes']),
    ...mapState('space/tags', ['tags_list']),
    ...mapState('space/accounts', ['accounts']),
    ...mapGetters('space/accounts', ['accounts_by_groups']),
    ...mapGetters('space/expenses', ['expenses_by_groups']),
    ...mapGetters('space/contractors', ['contractorsByPopularity']),
    computedContractors() {
      return this.contractorsByPopularity(this.transaction_item.type)
    }
  },
  methods: {
    ...mapActions('space/tags', ['createTag']),
    addTag(val) {
      const tag = {title: val, space_id: this.current_space.data.id};
      this.createTag(tag).then(res => {
        if (res.body.success) {
          this.form.tags.push(res.body.data);
          this.$store.commit('space/tags/pushTag', res.body.data);
        }
      })
    },
    handleFee() {
      const {account, sum} = this.form;

      if (!!account && account.commission && !!sum) {
        if (account.commission_type === 1) {
          const s = sum * 100,
              f = +account.commission_value;
          this.form.fee = +(s * f / 10000).toFixed(account.currency.decimals);
        } else {
          this.form.fee = +account.commission_value;
        }
      } else {
        this.form.fee = null;
      }
    },
    setFields(transaction) {
      this.form.sum = !!transaction.commission ? transaction.sum - transaction.commission : transaction.sum;
      this.form.sum = this.form.sum.toFixed(transaction.account.currency.decimals)
      this.form.fee = !!transaction.commission ? transaction.commission : 0;
      this.form.account = transaction.account;
      this.form.expenseCategory = transaction.expense;
      this.form.incomeCategory = transaction.income;
      this.form.contractor = transaction.contractor;
      this.form.comment = !!transaction.comment ? transaction.comment : '';
      this.form.tags = transaction.tags;

      this.form.date = this.$moment.unix(transaction.date).format('YYYY-MM-DD');
      this.form.time = this.$moment.unix(transaction.date).format('HH:mm');

      this.form.off_report = transaction.off_report;
      this.form.off_budget = transaction.off_budget;
    },
    prepareData(payload) {
      let data = {}

      //transaction data
      data.id = this.transaction_item.id;
      data.account_id = payload.account.id;
      if (this.transaction_item.type === 2) {
        data.sum = payload.account.commission_type !== null ? (+payload.sum + +payload.fee) : +payload.sum;
        data.expense_category_id = !!payload.expenseCategory ? payload.expenseCategory.id : '';
        data.commission = payload.account.commission_type !== null ? +payload.fee : null;
      }
      if (this.transaction_item.type === 1) {
        data.sum = +payload.sum;
        data.income_source_id = !!payload.incomeCategory ? payload.incomeCategory.id : '';
      }
      data.contractor_id = (this.transaction_options.agent && !!payload.contractor) ? payload.contractor.id : '';
      if (!!this.transaction_item.import_id) {
        data.update_categories = this.form.update_categories;
      }

      data.date_time = this.current_space.data.time_enabled ?
          `${payload.date} ${payload.time}:${this.$moment().format('ss')}` :
          `${payload.date} ${this.$moment().format('HH:mm:ss')}`;
      data.timezone = this.$moment.tz.guess();

      data.comment = this.transaction_options.comment ? payload.comment : '';
      data.tag_ids = this.transaction_options.tags ? payload.tags.map(i => i.id) : [];

      data.off_report = this.form.off_report;
      data.off_budget = this.form.off_budget;


      return data;
    },
    saveChanges() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const data = this.prepareData(this.form);

        this.$emit('updateTransaction', data)

      }
    },
    removeOperation() {
      this.$emit('removeTransaction', this.transaction_item.id)
    }
  },
  watch: {
    transaction_item: {
      immediate: true,
      handler(newVal) {
        if (!!newVal) {
          this.setFields(newVal)
        }
      }
    },
    'form.sum': {
      handler() {
        this.handleFee();
      }
    },
    'form.account': {
      handler() {
        this.handleFee()
      }
    }
  },
  i18n: {
    messages: {
      en: {
        fieldRequired: 'Field is required',
        sum: 'Sum',
        commission: 'Commission',
        accountFrom: 'From account',
        accountTo: 'To account',
        categoryExpense: 'Expense category',
        categoryIncome: 'Income category',
        updateCategoriesText: 'Change category for all operations with the same description',
        contractor: 'Contractor',
        noContractors: 'You have no contractors, you can add them',
        noContractorsHere: 'here',
        comment: 'Comment',
        tags: 'Tags',
        tagCreateNew: 'Create new',
        noTags: 'You have no tags, enter name to create the new tag',
        isReportText: 'ignore in reports',
        isBudgetText: 'ignore in budgets',
        dateLabel: 'Transaction date',
        timeLabel: 'Transaction time',
        saveChanges: 'Save changes',
        cancel: 'Cancel',
        remove: 'Delete',
      },
      ru: {
        fieldRequired: 'Поле обязательно',
        sum: 'Сумма',
        commission: 'Комиссия',
        accountFrom: 'Со счета',
        accountTo: 'На счет',
        categoryExpense: 'Категория расхода',
        categoryIncome: 'Категория дохода',
        updateCategoriesText: 'Изменить категорию для всех операций с таким же описанием',
        contractor: 'Контрагент',
        noContractors: 'У вас пока нет контрагентов, вы можете добавить их',
        noContractorsHere: 'здесь',
        comment: 'Комментарий',
        tags: 'Теги',
        tagCreateNew: 'Добавить новый',
        noTags: 'У вас нет тегов, введите название первого тега',
        isReportText: 'не учитывать сумму в отчетах',
        isBudgetText: 'не учитывать сумму в бюджетах',
        dateLabel: 'Дата операции',
        timeLabel: 'Время операции',
        saveChanges: 'Сохранить изменения',
        cancel: 'Отмена',
        remove: 'Удалить',
      }
    }
  }
}
</script>